import Stack from '@admin/components/stack'
import Categories from './categories'
import PropTypes from 'prop-types'
import Articles from './articles'
import Article from './article'
import React from 'react'

class Help extends React.Component {

  static contextTypes = {
    portal: PropTypes.object
  }

  static propTypes = {
    onBack: PropTypes.func,
    onCancel: PropTypes.func
  }

  stackRef = React.createRef()

  _handleArticle = this._handleArticle.bind(this)
  _handleArticles = this._handleArticles.bind(this)
  _handleCategory = this._handleCategory.bind(this)
  _handleClose = this._handleClose.bind(this)
  _handlePop = this._handlePop.bind(this)
  _handlePush = this._handlePush.bind(this)

  render() {
    return (
      <div className="maha-help">
        <Stack { ...this._getStack() } />
      </div>
    )
  }

  _getCategories() {
    const { onBack, onCancel } = this.props
    return {
      onCategory: this._handleCategory,
      onArticle: this._handleArticle,
      ...onBack ? { onBack } : {},
      ...onCancel ? { onCancel } : {}
    }
  }

  _getArticles() {
    return {
      onArticle: this._handleArticle,
      onClose: this._handleClose
    }
  }

  _getArticle(id) {
    return {
      id,
      onArticle: this._handleArticle,
      onBack: this._handlePop
    }
  }

  _getCategory(category) {
    return {
      category,
      onArticle: this._handleArticle,
      onBack: this._handlePop
    }
  }

  _getStack() {
    return {
      display_name: 'help_articles',
      initial: [
        { component: Categories, props: this._getCategories() }
      ],
      ref: this.stackRef
    }
  }

  _handleArticles() {
    this._handlePush(Article, this._getArticles())
  }

  _handleArticle(id) {
    this._handlePush(Article, this._getArticle(id))
  }

  _handleCategory(category) {
    this._handlePush(Articles, this._getCategory(category))    
  }

  _handleClose() {
    this.context.portal.toggleHelp()
  }

  _handlePop() {
    this.stackRef.current.pop()
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }


}

export default Help
